// imove-behavior: 获取当前用户权限

export default async function(ctx) {
  const { getLocalStatus } = ctx.payload;
  if (getLocalStatus) {
    const status = await getLocalStatus();
    console.log('getLocalStatus',status);
    return status;
  }
  return null;
}